import clsx from 'clsx';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { useAppContext } from '@contexts/AppContext';
import useNativeAppVersionCheck from '@hooks/useNativeAppVersionCheck';
import { ContentType } from '@tracking';

import { BookmarkSize } from './constants';
import Bookmark from './index';

interface FeedBookmarkProps {
  className?: string;
  contentId: number;
  contentType: ContentType;
}

// Shared so every feed bookmark coalesces into the module-level lookup batcher
// regardless of which host provides a client.
const queryClient = new QueryClient();

// Gates the bookmark to active subscribers (including CBPT). Leads,
// non-subscribers, and logged-out users render nothing, so no lookup is fired.
const FeedBookmark = ({ className, contentId, contentType }: FeedBookmarkProps) => {
  const { initialCurrentUser } = useAppContext();
  const { isApp3_0OrGreater, isNativeApp } = useNativeAppVersionCheck();

  if (!initialCurrentUser?.is_subscriber || !isNativeApp || !isApp3_0OrGreater) {
    return null;
  }

  return (
    <div className={clsx('flex items-center', className)}>
      <QueryClientProvider client={queryClient}>
        <Bookmark contentId={contentId} contentType={contentType} size={BookmarkSize.Small} />
      </QueryClientProvider>
    </div>
  );
};

export default FeedBookmark;
